import React from 'react'

import styles from './InputCheck.module.scss'

const InputCheck = () => {
  return <input type="checkbox" className={styles.inputCheck} />
}

export default InputCheck
